module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['wrapper', _vm.classes]
  }, [_c('header', {
    staticClass: "main-header"
  }, [_vm._m(0), _vm._v(" "), _c('nav', {
    staticClass: "navbar navbar-static-top",
    attrs: {
      "role": "navigation"
    }
  }, [_vm._m(1), _vm._v(" "), _c('span', {
    staticClass: "navmenu"
  }, [_vm._v("\n         Merchant Portal - "), _c('small', [_vm._v(" " + _vm._s(_vm.$route.name.toUpperCase()) + " ")])]), _vm._v(" "), _c('div', {
    staticClass: "navbar-custom-menu"
  }, [_c('ul', {
    staticClass: "nav navbar-nav"
  }, [_c('li', {
    staticClass: "dropdown user user-menu"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "#",
      "data-toggle": "dropdown"
    }
  }, [_c('span', {
    staticClass: "hidden-xs"
  }, [_vm._v(_vm._s(this.user.firstName + " " + this.user.lastName) + " "), _c('span', {
    staticClass: "caret"
  })])]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', {
    staticClass: "user-header"
  }, [_c('v-icon', {
    attrs: {
      "x-large": "",
      "color": "white"
    }
  }, [_vm._v("account_circle")]), _vm._v(" "), _c('p', [_vm._v("\n                    " + _vm._s(this.user.firstName + " " + this.user.lastName) + "\n                    "), _c('small', [_vm._v(_vm._s(this.user.role))])])], 1), _vm._v(" "), _c('li', {
    staticClass: "user-footer"
  }, [_c('div', {
    staticClass: "pull-left"
  }, [_c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/user/updatepassword"
    }
  }, [_c('v-btn', {
    attrs: {
      "small": ""
    }
  }, [_vm._v(" Profile ")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('v-btn', {
    attrs: {
      "small": ""
    },
    on: {
      "click": _vm.logout
    }
  }, [_vm._v(" Log Out ")])], 1)])])])])])])]), _vm._v(" "), _c('sidebar', {
    attrs: {
      "display-name": _vm.demo.displayName,
      "picture-url": _vm.demo.avatar
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [_c('router-view')], 1), _vm._v(" "), _c('footer', {
    staticClass: "main-footer"
  }, [_c('strong', [_vm._v("Copyright © " + _vm._s(_vm.year) + "\n      "), _c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("Co-operative Bank")]), _vm._v(".")]), _vm._v(" All rights reserved.\n  ")])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "logo",
    staticStyle: {
      "padding-left": "0px",
      "padding-right": "0px"
    },
    attrs: {
      "href": "/"
    }
  }, [_c('span', {
    staticClass: "logo-lg"
  }, [_c('img', {
    staticClass: "img-responsive logo",
    staticStyle: {
      "background-color": "white"
    },
    attrs: {
      "src": "/static/img/logo_white_bg.png",
      "alt": "Logo",
      "width": "230px"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "logo-mini",
    staticStyle: {
      "background-color": "#f2f2f2"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "sidebar-toggle",
    attrs: {
      "href": "javascript:;",
      "data-toggle": "offcanvas",
      "role": "button"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle navigation")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a8fdb2d8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dash.vue
// module id = 1068
// module chunks = 2